export const WASTE = {
  page: 'waste-page',
  tabProjects: 'waste-tab-projects',
  tabInbox: 'waste-tab-inbox',
  tabSubs: 'waste-tab-subs',
  projectItem: (id) => `waste-project-${id}`,
  projectDetail: 'waste-project-detail',
  gapCard: 'waste-gap-card',
  targetsBtn: 'waste-targets-edit',
  targetField: (k) => `waste-target-field-${k}`,
  targetsSave: 'waste-targets-save',
  takeoverBtn: 'waste-takeover-btn',
  takeoverDate: 'waste-takeover-date',
  takeoverConfirm: 'waste-takeover-confirm',
  takeoverInfo: 'waste-takeover-info',
  beforeAfter: 'waste-before-after',
  baRow: (k) => `waste-ba-row-${k}`,
  afterEvidence: (k) => `waste-after-evidence-${k}`,
  issueBtn: 'waste-issue-btn',
  issueField: (n) => `waste-issue-field-${n}`,
  issueConfirm: 'waste-issue-confirm',
  issuedBanner: 'waste-issued-banner',
  exportPdf: 'waste-export-pdf',
  projectReportRow: (id) => `waste-project-report-${id}`,
  reportRow: (id) => `waste-report-row-${id}`,
  statusFilter: 'waste-status-filter',
  newReportBtn: 'waste-new-report',
  behalfDialog: 'waste-behalf-dialog',
  behalfSub: 'waste-behalf-sub',
  behalfSave: 'waste-behalf-save',
  review: 'waste-review-dialog',
  reviewStatus: 'waste-review-status',
  acceptBtn: 'waste-accept-btn',
  returnComment: 'waste-return-comment',
  returnBtn: 'waste-return-btn',
  submitBehalfBtn: 'waste-submit-behalf',
  saveEditBtn: 'waste-save-edit',
  aiDraftBtn: 'waste-ai-draft',
  aiText: 'waste-ai-text',
  aiSave: 'waste-ai-save',
  subAddBtn: 'waste-sub-add',
  subCard: (id) => `waste-sub-${id}`,
  subEdit: (id) => `waste-sub-edit-${id}`,
  subLogin: (id) => `waste-sub-login-${id}`,
  subScore: (id) => `waste-sub-score-${id}`,
  subField: (n) => `waste-sub-field-${n}`,
  subProject: (id) => `waste-sub-project-${id}`,
  subSave: 'waste-sub-save',
  loginField: (n) => `waste-login-field-${n}`,
  loginSave: 'waste-login-save',
  scorecard: 'waste-scorecard',
  scoreStat: (k) => `waste-score-${k}`,
};

export const EDITOR = {
  project: 'report-project',
  period: 'report-period',
  line: (i) => `report-line-${i}`,
  lineField: (i, n) => `report-line-${i}-${n}`,
  addLine: 'report-add-line',
  removeLine: (i) => `report-remove-line-${i}`,
  evidenceKind: 'report-evidence-kind',
  evidenceUpload: 'report-evidence-upload',
  evidenceItem: (i) => `report-evidence-${i}`,
  removeEvidence: (i) => `report-remove-evidence-${i}`,
  notes: 'report-notes',
};

export const SUBP = {
  page: 'sub-portal',
  company: 'sub-company',
  project: (id) => `sub-project-${id}`,
  newReport: 'sub-new-report',
  report: (id) => `sub-report-${id}`,
  dialog: 'sub-report-dialog',
  save: 'sub-report-save',
  submit: 'sub-report-submit',
  remove: 'sub-report-delete',
  comments: 'sub-report-comments',
  logout: 'sub-logout',
};
